import React from "react";

import { ToolbarComponent } from "./ToolbarComponent";
import { GenericDataAccess } from "../datacontrols/GenericDataAccess";
import { GenericListComponent } from "./GenericListComponent";
import { GenericDisplayComponent } from "./GenericDisplayComponent";
import { withConfirmationWrapper } from "./ConfirmationWrapper";

export var InterfaceMode = {
    List: 0,
    Display: 1,
    Edit: 2,
    New: 3,
};

class GenericComponent extends React.Component {
    constructor(props) {
        super(props);

        this.logger = window.BaseLogger;
        this.dataAccess = new GenericDataAccess();

        this.state = {
            mode: this.props.dataId ? InterfaceMode.Display : InterfaceMode.List,
            itemId: this.props.dataId ? this.props.dataId : null,
        };

        this.itemId = null;
        this.onListClick = this.onListClick.bind(this);
        this.onDisplayClick = this.onDisplayClick.bind(this);
        this.onNewClick = this.onNewClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onRowSelected = this.onRowSelected.bind(this);
        this.onInputCompleted = this.onInputCompleted.bind(this);
        this.onCloneClick = this.onCloneClick.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onPdfClick = this.onPdfClick.bind(this);

        console.log("debug:::genericcomponent", this.props.dataId);
    }

    onListClick() {
        this.setState({
            mode: InterfaceMode.List,
            itemId: null,
        });
        this.notifiyOnModeChange(InterfaceMode.List);
    }

    onDisplayClick() {
        this.setState({
            mode: InterfaceMode.Display,
        });
        this.notifiyOnModeChange(InterfaceMode.Display);
    }

    onNewClick() {
        this.setState({
            mode: InterfaceMode.New,
            itemId: null,
        });
        this.notifiyOnModeChange(InterfaceMode.New);
    }

    onEditClick() {
        this.setState({
            mode: InterfaceMode.Edit,
        });
        this.notifiyOnModeChange(InterfaceMode.Edit);
    }

    onRowSelected(item) {
        this.itemId = item.id;
        this.setState({
            mode: InterfaceMode.Display,
            itemId: item.id,
        });
        this.notifiyOnModeChange(InterfaceMode.Display);
    }

    onCloneClick() {
        var self = this;
        self.dataAccess.getItem(self.props.dataObject, self.state.itemId, function (result) {
            if (result) {
                var item = result;
                item.id = 0;
                self.dataAccess.saveItem(self.props.dataObject, item, function (result) {
                    //Alerts.showSuccess('The item has been cloned', 'Clone');
                    self.props.notifications.info({
                        message: "The item has been cloned.",
                    });
                    var item = result;
                    self.setState({
                        mode: InterfaceMode.Edit,
                        itemId: item.id,
                    });
                    self.notifiyOnModeChange(InterfaceMode.Edit);
                });
            }
        });
    }

    onDeleteClick() {
        var self = this;
        self.props.confirmation
            .show({
                content: "The item will be deleted. Do you want to continue?",
                title: "Delete Item",
            })
            .then((response) => {
                console.log("debug:::deleted");
                self.dataAccess.deleteItem(self.props.dataObject, self.state.itemId, function () {
                    self.props.notifications.info({
                        message: "The item has been deleted.",
                    });
                    self.onListClick();
                });
            });
        // Confirmation.show('Delete', 'The item will be deleted. Do you want to continue?',
        //     function () {
        //         self.dataAccess.deleteItem(self.props.dataObject, self.state.itemId, function () {
        //             //Alerts.showSuccess('The item has been deleted.', 'Delete');
        //             self.props.notifications.info({
        //                 message: "The item has been deleted."
        //             })
        //             self.onListClick();
        //         });
        //     }
        // );
    }

    onInputCompleted() {
        this.setState({
            mode: InterfaceMode.List,
            itemId: null,
        });
        this.notifiyOnModeChange(InterfaceMode.List);
    }

    notifiyOnModeChange(mode) {
        if (this.props.onModeChange) {
            this.props.onModeChange(mode, this.props.dataObject, this.itemId);
        }
    }

    onPdfClick() {
        //?format={format}&filter={filter}&title={title}&recordId={recordId}
        var url = this.props.title
            ? "/api/" +
              encodeURI(this.props.dataObject) +
              "?format=pdf&filter=null&title=" +
              encodeURI(this.props.title) +
              "&recordId=" +
              encodeURI(this.state.itemId)
            : "/api/" +
              encodeURI(this.props.dataObject) +
              "?format=pdf&filter=null&recordId=" +
              encodeURI(this.state.itemId);

        window.location = url;
    }

    render() {
        var self = this;
        return (
            <div className="generic-component">
                <ToolbarComponent
                    mode={this.state.mode}
                    enableNew={this.props.enableNew}
                    enableEdit={this.props.enableEdit}
                    enableClone={this.props.enableClone}
                    enableDelete={this.props.enableDelete}
                    onNewClick={this.onNewClick}
                    onEditClick={this.onEditClick}
                    onListClick={this.onListClick}
                    onDisplayClick={this.onDisplayClick}
                    onCloneClick={this.onCloneClick}
                    onDeleteClick={this.onDeleteClick}
                    onPdfClick={this.onPdfClick}
                />

                {this.state.mode == InterfaceMode.List && (
                    <GenericListComponent
                        id="list_module"
                        dataObject={this.props.dataObject}
                        onRowSelected={this.onRowSelected}
                        filter={this.props.filter}
                        enableDelete={this.props.enableDelete}
                        confirmation={this.props.confirmation}
                    />
                )}

                {this.state.mode == InterfaceMode.Display && (
                    <GenericDisplayComponent dataObject={this.props.dataObject} dataId={this.state.itemId} />
                )}
                {/*

                {this.state.mode == InterfaceMode.Edit &&
                    <GenericInputComponent dataObject={this.props.dataObject} dataId={this.state.itemId} onCompleted={this.onInputCompleted} />
                }

                {this.state.mode == InterfaceMode.New &&
                    <GenericInputComponent dataObject={this.props.dataObject} dataId={null} onCompleted={this.onInputCompleted} />
                } */}
            </div>
        );
    }
}
export default withConfirmationWrapper(GenericComponent);
